import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import Driver from '@/plugins/driver'
import '@/plugins/mf-vue-components'

import VueEllipseProgress from 'vue-ellipse-progress'
import VueLuxon from 'vue-luxon'
import Moment from 'moment-timezone'
import VueMomentLib from 'vue-moment-lib'
import VueWait from 'vue-wait'
import LoggedUser from '@/plugins/logged-user/loggedUser.js'
import Whitelabel from '@/plugins/whitelabel/whitelabel.js'
import Microservices from '@/plugins/microservices/microservices.js'
import Permission from '@/plugins/permission/permission.js'
import VueBus from './plugins/event-bus'
import Confirm from '@/plugins/confirm/confirm.js'
import Alert from '@/plugins/alert/alert.js'
import Snackbar from '@/plugins/snackbar/snackbar.js'
// import sendSlackFireNotifier from '@/plugins/slack-fire-notifier'
import Vuelidate from 'vuelidate'
import VueShortkey from 'vue-shortkey'
import i18n from '@/plugins/i18n'
import VueClipboards from 'vue-clipboards'
// import VueIntercom from 'vue-intercom'
import VueScrollTo from 'vue-scrollto'
import VueTheMask from 'vue-the-mask'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueHtmlToPaper from 'vue-html-to-paper'
import VueApexCharts from 'vue-apexcharts'
import VueConfetti from 'vue-confetti'

// filters
import filterLocaleString from '@/filters/localeString.js'
import filterPercent from '@/filters/percent.js'
import filterCurrency from '@/filters/currency.js'
import filterGenericFormatter from '@/filters/genericFormatter.js'
import filterAbreviation from '@/filters/abreviation.js'
import filterTelefone from '@/filters/telefone.js'
import filterFilesize from '@/filters/filesize.js'
import filterCpf from '@/filters/cpf.js'
import filterCnpj from '@/filters/cnpj.js'
import filterCpfCnpj from '@/filters/cpfCnpj.js'
import filterHifen from '@/filters/hifen.js'
import filterDate from '@/filters/date.js'
import filterTruncate from '@/filters/truncate.js'
import filterPii from '@/filters/pii.js'

// mixins
import { localeString, inputOnlyRegex } from '@/config/helpers.js'

// External libraries
import { activateHotjar } from '@/external-libs/hotjar.js'

// Graphql
import { apolloProvider } from '@/apollo-provider.js'

// Luxon
import { Settings } from 'luxon'

// MF Components
import MFTextareaEmoji from '@/components/MFTextareaEmoji.vue'
import MFQuickActions from '@/components/quick-actions/MFQuickActions.vue'

// Userflow: Users onboardings
import userflow from 'userflow.js'
userflow.init('ct_ze44t7egirf6ndjkxnz4aengdq')
userflow.setResourceCenterLauncherHidden(true)

const MAINTENANCE_MODULES = [] // same as sidemenu pages: 'campanhas', 'clube', etc. '*' for everything
const MAINTENANCE_ACCOUNT_IDS = [] // accountId or '*' for everyone
const MAINTENANCE_RETURN_FORECAST = '' // hh:mm format: '22:00', '12:00'
store.commit('SET_MAINTENANCE_RETURN_FORECAST', MAINTENANCE_RETURN_FORECAST)
store.commit('SET_MAINTENANCE_MODULES', MAINTENANCE_MODULES)
store.commit('SET_MAINTENANCE_ACCOUNT_IDS', MAINTENANCE_ACCOUNT_IDS)

Vue.filter('localeString', filterLocaleString)
Vue.filter('percent', filterPercent)
Vue.filter('currency', filterCurrency)
Vue.filter('genericFormatter', filterGenericFormatter)
Vue.filter('abreviation', filterAbreviation)
Vue.filter('telefone', filterTelefone)
Vue.filter('filesize', filterFilesize)
Vue.filter('cpf', filterCpf)
Vue.filter('cnpj', filterCnpj)
Vue.filter('cpfCnpj', filterCpfCnpj)
Vue.filter('hifen', filterHifen)
Vue.filter('date', filterDate)
Vue.filter('pii', filterPii)
Vue.filter('truncate', filterTruncate)

Moment.locale('pt-BR')
const moment = Moment.tz.setDefault('America/Bahia')
Vue.use(VueMomentLib, { moment })

Settings.defaultLocale = 'pt-BR'
Vue.use(VueLuxon, {
  input: {
    zone: 'America/Sao_Paulo',
  },
  output: {
    locale: 'pt-BR',
    zone: 'America/Sao_Paulo',
  },
})
Vue.use(Driver)
Vue.use(VueEllipseProgress)
Vue.use(LoggedUser)
Vue.use(Whitelabel, { env: process.env })
Vue.use(Microservices, { env: process.env })
Vue.use(Permission)
Vue.use(Confirm, { vuetify })
Vue.use(Alert, { vuetify })
Vue.use(VueWait)
Vue.use(Snackbar)
Vue.use(VueShortkey)
Vue.use(VueClipboards)
Vue.use(VueConfetti)
// Vue.use(VueIntercom, { appId: 'as6vg8b9' })
Vue.use(VueTheMask)
Vue.use(VueHtmlToPaper)

Vue.use(VueBus)

Vue.use(Vuelidate)

Vue.use(VueScrollTo, {
  duration: 200,
  easing: 'linear',
  force: true,
  cancelable: true,
  x: true,
  y: false,
})
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.component('mf-textarea-emoji', MFTextareaEmoji)
Vue.component('mf-quick-actions', MFQuickActions)
Vue.component(VueQrcode.name, VueQrcode)
Vue.config.productionTip = false

// Mixins
Vue.mixin({
  computed: {
    hasPiiAccess() {
      return this.$hasPiiAccess()
    },
    hasPiiDownloadAccess() {
      return this.$hasPiiDownloadAccess()
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    localeString,
    inputOnlyRegex,
    scrollTo(selector, { offset = -80 } = {}) {
      let el = this.$el.querySelector(selector)
      if (!el) return
      const y = el.getBoundingClientRect().top + window.pageYOffset + offset
      window.scrollTo({ top: y, behavior: 'smooth' })
    },
    getSafe(fn) {
      try {
        return fn()
      } catch (e) {}
    },
    getIsQuickAction() {
      const quickAction = Boolean(this.$route.query.quick_action)

      if (quickAction) {
        // Removing query param
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {
            quick_action: undefined,
          },
        })
      }

      return quickAction
    },

    getIsPreFilter() {
      const isPreFilter = Boolean(this.$route.query.is_prefilter)

      if (isPreFilter) {
        // Removing query param
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {
            is_prefilter: undefined,
          },
        })
      }

      return isPreFilter
    },
  },
})
Vue.config.ignoredElements = ['vue-widget']

const fillUserPermissions = async () => {
  if (Vue.getIsAdmin()) {
    store.dispatch('setUserPermissions', ['mf/admin'])
  } else {
    const user = JSON.parse(window.localStorage.getItem('loggedUser'))
    if (!user) return
    await store.dispatch('getUserPermissions', user.id_user)
    if (user.is_franchisee) await store.dispatch('getFranchiseePermissions', user.id_user)
  }
}

// Verify if route is in maintenance for current user
const isRouteInMaintenance = (to, accountId) => {
  const isAccountInMaintenance = MAINTENANCE_ACCOUNT_IDS.includes('*') || MAINTENANCE_ACCOUNT_IDS.includes(accountId)
  const isRouteInMaintenance = MAINTENANCE_MODULES.includes('*') || MAINTENANCE_MODULES.some((feature) => to.path.startsWith(`/${feature}`))

  return isAccountInMaintenance && isRouteInMaintenance
}

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || 'Mercafacil'
  const modulePermission = to.meta.permission ? Vue.getAllowedModules()[to.meta.permission] : true
  const accountId = Vue.getLoggedUser()?.id_account ?? null
  Vue.prototype.$currentRoute = Vue.currentRoute = to
  // Destroy ongoing tours when route changes
  Vue.$driver.driver.destroy()

  store.commit('RESET_QUICK_ACTIONS')
  // Store redirect if user was already logged with expired session
  // TODO login rota tratativa
  if (from.path !== '/login' && from.path !== '/expired-session' && from.path !== '/' && to.path === '/expired-session') {
    window.localStorage.setItem('redirectAfterLogin', from.fullPath)
  }
  // Store redirect if user is not logged
  if (!Vue.isLogged() && !['/login', '/expired-session', '/restrict-access'].includes(to.path)) {
    window.localStorage.setItem('redirectAfterLogin', to.fullPath)
  }
  if (Vue.isLogged() && to.path === '/login') {
    next({ path: '/' })
  }
  // Skip fetching permissions for expired-session page
  // to avoid loop of death
  if (!['/restrict-access', '/expired-session'].includes(to.path)) {
    await fillUserPermissions()
  }
  if (to.path !== '/maintenance' && accountId && isRouteInMaintenance(to, accountId)) {
    next({ path: '/maintenance' })
    return
  }
  if (!Vue.getIsAdmin() && Vue.getLoggedUser().only_mercapromo && !to.meta.allowOnlyMercapromo && to.path !== '/restrict-access') {
    console.log('restrict-access:2')
    next({ path: '/restrict-access' })
  }
  if (to.path !== '/restrict-access' && (!Vue.havePagePermission(to.meta.pagePermission) || (to.meta.requiresPiiAccess && !Vue.hasPiiAccess()))) {
    if (Vue.getIsEcommerce() && to.path === '/home') {
      next()
    } else {
      console.log('restrict-access:3')
      next({ path: '/restrict-access' })
      return
    }
  }
  if (
    to.path !== '/restrict-access' &&
    (!Vue.havePagePermission(to.meta.pagePermission) || (to.meta.requiresPiiEmployeesAccess && !Vue.hasPiiEmployeesAccess()))
  ) {
    if (Vue.getIsEcommerce() && to.path === '/home') {
      next()
    } else {
      console.log('restrict-access:1')
      next({ path: '/restrict-access' })
      return
    }
  }
  if (to.meta.unlogged) {
    if (Vue.isLogged()) {
      next({ path: '/home' })
    } else {
      next()
    }
  } else if (Vue.isLogged()) {
    store.commit('RESET_CAMPANHAS_MODULE')
    store.commit('RESET_CLIENTES_MODULE')
    store.commit('RESET_CLUBE_MODULE')
    // store.commit('RESET_EMPRESA_MODULE')
    store.commit('RESET_GEO_MODULE')
    store.commit('RESET_HOME_MODULE')
    store.commit('RESET_PRODUTOS_MODULE')
    store.commit('RESET_CALENDARIO_PROMOCIONAL_MODULE')
    store.commit('RESET_USUARIOS_MODULE')

    if (modulePermission) {
      // Extract generic path (with :id placeholders instead of actual values)
      const genericPath = to.matched.length > 0 ? to.matched[to.matched.length - 1].path : to.path
      console.log('trackRouteAccess:1')
      store.dispatch('trackRouteAccess', {
        genericRoute: genericPath,
        route: to.path,
      })

      next()
    } else {
      next({ path: '/home' })
    }
  }
})

const user = JSON.parse(window.localStorage.getItem('loggedUser'))
if (window.Conpass) {
  window.Conpass.init({
    name: user.name,
    email: user.username,
    client: user.client,
    id_external: user.id_external,
  })
}

const isAdmin = Vue.getIsAdmin()

/* External libraries */

// if (allowedModules && allowedModules.hotjar) {
if (!isAdmin && Boolean(Vue.getLoggedUser())) {
  activateHotjar(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
}

Vue.prototype.$goTo = Vue.goTo = (path) => {
  router.push(path.startsWith('#') ? path.slice(1) : path)
}

// Vue.config.errorHandler = async (err, vm, info) => {
//   const request = { context: { uri: 'Não se aplica' } }
//   await sendSlackFireNotifier({
//     title: 'Erro VueJS',
//     error: err.message,
//     vm,
//     info,
//     operation: '',
//     request,
//   })
// }

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  wait: new VueWait({ useVuex: true }),
  vuetify,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app')
